import { MdOutlineEmail, MdOutlinePhone } from 'react-icons/md';
import { TbWorld } from "react-icons/tb";

type ContactInfo = {
  phone?: string;
  email?: string;
  website?: string;
};

function RestaurantContact({ contactInfo }) {
  if (!contactInfo) return null;

  return (
    <div className="flex flex-wrap items-center gap-4 text-gray-700">
      {contactInfo.website && (
        <div className="flex items-center gap-1 text-[#ea6f3e]">
          <TbWorld />
          <a
            href={contactInfo.website}
            target="_blank"
            rel="noopener noreferrer"
            className="underline font-bold sm:font-normal"
          >
            Visit Website
          </a>
        </div>
      )}

      {contactInfo.phone && (
        <div className="flex items-center gap-1 text-[#ea6f3e]">
          <MdOutlinePhone />
          <a href={`tel:${contactInfo.phone}`} className="underline font-bold sm:font-normal">
            Call
          </a>
        </div>
      )}

      {contactInfo.email && (
        <div className="flex items-center gap-1 text-[#ea6f3e]">
          <MdOutlineEmail />
          <a href={`mailto:${contactInfo.email}`} className="underline font-bold sm:font-normal">
            Email
          </a>
        </div>
      )}
    </div>
  );
}

export default RestaurantContact